import { useState } from "react";

import { EvaluationTextarea } from "@/components/EvaluationField/EvaluationField";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

const noop = () => {};

export function PlaygroundEvaluationField() {
  const [comment, setComment] = useState(
    'The agent greeted the customer and said "Hello, how are you doing today?" which serves as an introduction. The company name was not explicitly stated, but the agent did open the call professionally.'
  );

  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          AI-evaluated marker (hasAiAnswer)
        </PlaygroundSubSectionTitle>
        <div className="flex w-[576px] flex-col gap-4">
          <EvaluationTextarea
            comment={comment}
            loading={false}
            aiAnswersTakingLonger={false}
            hasAiAnswer
            onChangeComment={(event) => setComment(event.target.value)}
          />
        </div>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Loading marker</PlaygroundSubSectionTitle>
        <div className="flex w-[576px] flex-col gap-4">
          <EvaluationTextarea
            comment=""
            loading
            aiAnswersTakingLonger={false}
            hasAiAnswer={false}
            onChangeComment={noop}
          />
        </div>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
